import React, {FC} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface MessageBannerSubtitleProps {
  color?: string;
}

/*
 * Style.
 */

interface TitleStyleProps {
  $color?: string;
}

const StyledSubtitleDiv = styled.div<TitleStyleProps>`
  grid-area: subtitle;

  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
  color: ${(p) => p.$color || p.theme.greys.white};

  ${ellipsis()};
`;

/*
 * Component.
 */

export const MessageBannerSubtitle: FC<MessageBannerSubtitleProps> = (props) => (
  <TooltipCoordinator render={() => props.children}>
    <StyledSubtitleDiv $color={props.color}>
      <TooltipOverflowCondition>{props.children}</TooltipOverflowCondition>
    </StyledSubtitleDiv>
  </TooltipCoordinator>
);
